import * as i18next from 'i18next'
import ReactDOM from 'react-dom'
import { root } from './EntryPoint/Frontend/root/root.widget'
import { dataLayerServices } from './EntryPoint/Frontend/seo/datalayer'
// STYLING IMPORTS
import './Shared/Frontend/utils/svgSymbols'
import './styling/custom-theme/stylesheets/spa.scss' // PROJECT
import { State } from './EntryPoint/Frontend/root/root.state'

export const main = async (cms_type: string, useSSR: boolean) => {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  const res = await fetch('/translations.json', { method: 'get', credentials: 'include', headers: headers })
  let resources = await res.json()
  let defaultLanguage = 'nl'
  i18next.init({
    lng: 'nl',
    fallbackLng: defaultLanguage,
    resources: resources
  })

  dataLayerServices.sendPendingGtmEvents()

  let state: State | undefined = undefined

  ReactDOM.render(
    root().run(
      (s) => {
        state = s
        return s
      }
    ),
    document.querySelector('#root'),
    () => {
      removeLoader()
      const root = document.getElementById("root")
      const ssrRoot = document.getElementById("rootSSR")
      
      if (!useSSR) {
        ssrRoot?.parentNode?.removeChild(ssrRoot)
        return
      }

      let releaseCounter = 20

      let hasAsyncLoading = (e: any, parent: any) => {
        if(e == undefined) return false
        let entries = Object.entries(e)
        if ((e as any)["kind"] == "fromPromise") return false
        for (let [key, value] of  entries) {

          if(value == null || value == undefined) continue
          if (typeof value === 'function') continue
          if (value instanceof Date) continue
          

          if ((value as any)["type"] == "async-widget") {
            if ((value as any)["kind"] == "loading") {
              return true
            }
          }

          if (typeof value === 'string' || value instanceof String) continue
          let hasValueAsyncLoading = hasAsyncLoading(value, e)
          if(hasValueAsyncLoading) return true
        }
        return false
      }

      let removeSSR = () => {
        let interval = setInterval(() => {
          if(hasAsyncLoading(state, undefined) && releaseCounter > 0) {
            releaseCounter--
            return
          }

          if (root) {
            root.style.display = ""
          }
          if (ssrRoot) {
            ssrRoot.style.display = "none"
            setTimeout(() => ssrRoot.parentNode?.removeChild(ssrRoot), 100)
          }
          clearInterval(interval)
        }, 200)
      }

      removeSSR()
    },
  )
}

function removeLoader() {
  const loader = document.querySelector('#js--loader')
  if (loader == null) return
  loader.remove()
}

if(window["run_main" as any]){
  main(window["cms_type" as any] as any, window["useSSR" as any] as any)
}